"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_find__and__ring__yourice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "95eedcaf-2c32-4946-a19a-d67860715508",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "find-and-ring-your-device"), /*#__PURE__*/React.createElement("circle", {
    id: "f7206cce-6285-42c7-95e3-b82eddaa783a",
    "data-name": "shape",
    cx: 75.32,
    cy: 76.04,
    r: 24,
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "83ce694e-bda3-4b95-936f-fd7c36f6eef3",
    "data-name": "shape",
    d: "M89.07,148c13.89-17.07,33-46.11,33-71,0-26.63-19.71-49-46.75-49S28.6,49.58,28.6,76.2c0,37.14,46.75,87.8,46.75,87.8S85.74,152.06,89.07,148Z",
    transform: "translate(-0.02 -0.02)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "06eef4fa-0bf5-431c-ac10-5542c58c7b9e",
    "data-name": "Shape",
    d: "M158.78,59.06a31.4,31.4,0,0,1,0,34",
    transform: "translate(-0.02 -0.02)",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b918e17e-2236-4685-b172-2e49427e6299",
    "data-name": "Shape",
    d: "M141,64.06a20,20,0,0,1,0,24",
    transform: "translate(-0.02 -0.02)",
    strokeLinecap: "round"
  }));
}

var _default = ic_find__and__ring__yourice;
exports.default = _default;